var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sticky', { 'is-sticky': _vm.isSticky }]},[_c('div',{staticClass:"sticky-placeholder",style:(_vm.placeholderStyles)}),_c('div',{ref:"container",staticClass:"sticky-container",style:(_vm.containerStyles)},[_c('div',{staticClass:"sticky-container-inner",style:(_vm.containerInnerStyles)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }